import { HHourIntervals } from "@shared/src/public-api";
import { ManualAddressDto } from "./ManualAddressDto";

export class AddressManualAddressDto {
    public addressId: number;
    public manualAddress: ManualAddressDto;
    public unloadIntervals: HHourIntervals;
    public loadIntervals: HHourIntervals;
}